export { TabModal } from './component';
export type { TabModalProps } from './types';
